export default {
  categoryCols: {
    NAME: {
      field: 'name',
      multiple: true,
      required: true,
      displayType: 'stringedOptions',
    },
    'SUB CATEGORIES': {
      field: 'subCategories',
      multiple: false,
    },
  },
  tagCols: {
    NAME: {
      field: 'name',
      multiple: false,
      required: true,
    },
  },
};
